import { customFetch } from "./custom-fetch";
import { useMutation } from "@tanstack/react-query";

export interface GenerateRecurringResult {
  generated: number;
  estimatesGenerated: number;
  invoicesGenerated: number;
}

export async function generateRecurring(): Promise<GenerateRecurringResult> {
  return customFetch<GenerateRecurringResult>("/api/recurring/generate", {
    method: "POST",
  });
}

export function useGenerateRecurring() {
  return useMutation({
    mutationFn: generateRecurring,
  });
}

export interface ApproveRecurringResult {
  approved?: boolean;
  alreadyApproved?: boolean;
  recurringNextDate?: string;
  backfilledCount?: number;
}

export async function approveRecurring(invoiceId: number, backfill = false): Promise<ApproveRecurringResult> {
  return customFetch<ApproveRecurringResult>(`/api/invoices/${invoiceId}/approve-recurring`, {
    method: "POST",
    body: JSON.stringify({ backfill }),
    headers: { "Content-Type": "application/json" },
  });
}

export function useApproveRecurring() {
  return useMutation({
    mutationFn: (args: number | { invoiceId: number; backfill?: boolean }) =>
      typeof args === "number"
        ? approveRecurring(args)
        : approveRecurring(args.invoiceId, args.backfill ?? false),
  });
}
